import React, { useContext } from "react";
import { FaSearch } from "react-icons/fa";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import { BaseURL } from "../../../../Files/BaseURL";
import { useState } from "react";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { useEffect } from "react";
import { formatDateForInput } from "../../../../Files/UseFunction";

const BillingHistory = () => {
  const { theme } = useContext(ThemeContext);
  const { showAlert } = useContext(AlertContext);

  const [billingHistory, setBillingHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalBills, setTotalBills] = useState(0);

  const fetchDetails = async (page = currentPage) => {
    try {
      setLoading(true);
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(
        `${BaseURL}/api/billing/billingList?page=${page}&limit=${itemsPerPage}${
          searchTerm ? `&search=${searchTerm}` : ""
        }`,
        {
          method: "GET",
          headers: {
            "auth-token": authToken,
          },
        }
      );

      const data = await response.json();
      if (response.ok && data.success) {
        setBillingHistory(data.bills);
        setTotalPages(data.pagination.totalPages);
        setTotalBills(data.pagination.totalBills);
      } else {
        showAlert(data.message || "Error fetching details", "danger");
      }
    } catch (e) {
      showAlert("Error fetching details", "danger");
    } finally {
      setLoading(false);
    }
  };

  // Fetch bills when component mounts or search term changes
  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filters change
    fetchDetails(1);
  }, [searchTerm, itemsPerPage]);

  // Fetch bills when page changes
  useEffect(() => {
    fetchDetails(currentPage);
  }, [currentPage]);

  // Update search input
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="py-6 md:py-10 max-w-[95%] md:max-w-[95%] m-auto">
      <div>
        <div className="flex flex-col gap-4 lg:flex-row justify-between font-pop lg:items-center">
          <div className="flex gap-2 md:gap-6 items-center">
            <h3
              className={`text-gray-400 text-sm md:text-lg font-medium ${
                theme === "dark" && "text-white"
              }`}
            >
              Total {totalBills} Record
            </h3>
          </div>
          <div
            className={`flex gap-3 items-center rounded-full py-1 px-4 ${
              theme === "dark" ? "bg-black text-white" : "bg-gray-300"
            }`}
          >
            <FaSearch
              className={`text-gray-400 text-lg md:text-2xl ${
                theme === "dark" && "text-white"
              }`}
            />
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search..."
              className="bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none"
            />
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-10">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primarygreen"></div>
          </div>
        ) : (
          <>
            <div
              className={`bg-transparent overflow-x-scroll font-pop w-full my-2 md:my-6`}
            >
              <table className="w-full overflow-x-scroll border-spacing-y-4 border-separate">
                <thead>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500  ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500  ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Document
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left w-[30%] font-medium text-gray-500 ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Service
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500  ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Order
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500  ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Method
                  </th>
                  <th
                    scope="col"
                    className={`px-2 md:px-6 py-1 md:py-3 text-left font-medium text-gray-500  ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Total
                  </th>
                </thead>
                <tbody>
                  {billingHistory?.map((item, index) => (
                    <tr key={index}>
                      <td
                        className={`px-2 md:px-6 rounded-l-2xl text-sm md:text-bas my-3 py-3 text-left  ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        } `}
                      >
                        <p
                          className={`w-max text-lightGrey ${
                            theme == "dark" && "text-white"
                          }`}
                        >
                          {formatDateForInput(item?.date)}
                        </p>
                      </td>
                      <td
                        className={`px-2 md:px-6  my-3 text-sm md:text-base font-semibold py-3 text-left w-max min-w-[30%] ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        } `}
                      >
                        <div className="flex font-medium flex-col gap-2">
                          <h2>Invoice</h2>
                          <h2 className="w-max">{item?._id}</h2>
                        </div>
                      </td>
                      <td
                        className={`px-2 md:px-6  my-3 py-1 md:py-3 font-normal text-left ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        } `}
                      >
                        <h2 className="w-max">Payment for {item?.Type}</h2>
                      </td>
                      <td
                        className={`px-2 md:px-6 b my-3 py-1 md:py-3 text-left font-semibold ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        }`}
                      >
                        <h2 className="w-max">#{item?.PayPalOrderID}</h2>
                      </td>
                      <td
                        className={`px-2 md:px-6  my-3 py-1 md:py-3 text-left ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        }`}
                      >
                        <h2 className="w-max">{item?.PaymentMethod}</h2>
                      </td>
                      <td
                        className={`px-2 md:px-6 text-gray-400  my-3 py-1 md:py-3 text-left ${
                          theme == "dark" ? "bg-black text-white" : "bg-white"
                        }`}
                      >
                        <h2 className="w-max">${item?.Price + item?.Tax}</h2>
                      </td>
                      <td
                        className={`px-2 md:px-6 rounded-r-2xl text-gray-400  my-3 py-1 md:py-3 text-left ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        } `}
                      >
                        <div className="w-6 h-6 overflow-hidden">
                          <img
                            src="../../../../Assets/Prop/reciveicon.png"
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {billingHistory?.length > 0 && (
              <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4 rounded-lg">
                <div className="flex flex-1 justify-between sm:hidden">
                  {/* Mobile view */}
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                      currentPage === 1
                        ? "bg-gray-100 text-gray-400"
                        : "bg-white text-gray-700 hover:bg-gray-50"
                    } ring-1 ring-inset ring-gray-300 rounded-md`}
                  >
                    Previous
                  </button>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className={`relative ml-3 inline-flex items-center px-4 py-2 text-sm font-semibold ${
                      currentPage === totalPages
                        ? "bg-gray-100 text-gray-400"
                        : "bg-white text-gray-700 hover:bg-gray-50"
                    } ring-1 ring-inset ring-gray-300 rounded-md`}
                  >
                    Next
                  </button>
                </div>

                {/* Desktop view */}
                <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                  {/* Left side - Items per page */}
                  <div>
                    <div className="flex items-center gap-4 font-bold font-pop text-xs">
                      <select
                        value={itemsPerPage}
                        onChange={(e) =>
                          setItemsPerPage(Number(e.target.value))
                        }
                        className="block w-20 rounded-md border-0 py-1.5 pl-3 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primarygreen sm:text-sm sm:leading-6"
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      <p className="text-sm text-gray-700">items per page</p>
                    </div>
                  </div>

                  {/* Center - Items count */}
                  <div className="font-pop text-xs font-bold">
                    <p className="text-sm text-gray-700">
                      {`${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
                        currentPage * itemsPerPage,
                        totalBills
                      )} of ${totalBills} items`}
                    </p>
                  </div>

                  {/* Right side - Navigation and pages */}
                  <div className="flex items-center gap-4 font-bold font-pop text-xs">
                    <div className="flex items-center gap-2">
                      <p className="text-sm text-gray-700">Page</p>
                      <p className="text-sm font-bold text-gray-900">
                        {currentPage}
                      </p>
                      <p className="text-sm text-gray-700">of</p>
                      <p className="text-sm font-bold text-gray-900">
                        {totalPages}
                      </p>
                      <p className="text-sm text-gray-700">pages</p>
                    </div>
                    <nav
                      className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                      aria-label="Pagination"
                    >
                      <button
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                        className={`relative inline-flex items-center rounded-l-md px-2 py-2 ${
                          currentPage === 1
                            ? "bg-gray-100 text-gray-400"
                            : "bg-white text-gray-500 hover:bg-gray-50"
                        } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                      >
                        <span className="sr-only">Previous</span>
                        <svg
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>

                      <button
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        disabled={currentPage === totalPages}
                        className={`relative inline-flex items-center rounded-r-md px-2 py-2 ${
                          currentPage === totalPages
                            ? "bg-gray-100 text-gray-400"
                            : "bg-white text-gray-500 hover:bg-gray-50"
                        } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                      >
                        <span className="sr-only">Next</span>
                        <svg
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </nav>
                    {/* Pages display */}
                  </div>
                </div>
              </div>
            )}

            {/* Show no data message */}
            {billingHistory.length === 0 && (
              <div className="text-center py-4 font-pop text-lg font-medium">
                No Billing History found
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BillingHistory;
